module.exports = __webpack_public_path__ + "img/sleeve-studio-view.70224950.jpg";